import { render } from "./bw.vue?vue&type=template&id=7f64d5cf"
import script from "./bw.vue?vue&type=script&lang=js"
export * from "./bw.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\item\\jts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__